/**
 * InfoTip — a small "?" marker that reveals a one-line definition on hover or
 * keyboard focus. Used to annotate benchmark report column headers so each
 * metric is self-explaining without a separate legend. Accessible: the marker
 * is focusable and the definition is exposed to assistive tech via aria-label.
 *
 * `align` controls which way the bubble grows so it never clips off-screen:
 * 'center' (default) for interior columns, 'end' to anchor the bubble's right
 * edge to the marker for the rightmost columns.
 */
interface InfoTipProps {
  text: string;
  align?: 'center' | 'end';
}

export function InfoTip({ text, align = 'center' }: InfoTipProps): JSX.Element {
  return (
    <span className="info-tip" tabIndex={0} role="note" aria-label={text}>
      <span className="info-tip-mark" aria-hidden>
        ?
      </span>
      <span
        className={`info-tip-bubble${align === 'end' ? ' info-tip-bubble-end' : ''}`}
        role="tooltip"
      >
        {text}
      </span>
    </span>
  );
}
